import React, { useEffect, useState } from "react";
import Select from "react-select";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  GetServiceCaller,
  PostFormServiceCaller,
  PostServiceCaller,
} from "../../../services/serviceCaller";
import { API_URL } from "../../../constants";
import { toast } from "react-toastify";
import * as Yup from "yup";
import { updateNavbarHeading } from "../../../constants/layout/store/filterSlice";
import No_Image_Available from "../../../assets/No_Image_Available.jpg";
import { FaSpinner } from "react-icons/fa";

const AwardForm = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(updateNavbarHeading("Award"));
  }, []);

  const initialFormData = {
    EmployeeID: null,
    Name: "",
    Remarks: "",
    award_id: null,
    badge: null,
    badgePreview: null,
    image: null,
    imagePreview: null,
    score: "",
  };

  const [awardTypeOptions, setAwardTypeOptions] = useState([]);
  const [employeeOptions, setEmployeeOptions] = useState([]);
  const [description, setDescription] = useState([]);
  const [formData, setFormData] = useState(initialFormData);
  const [errors, setErrors] = useState({});
  const [pageLoading, setPageLoading] = useState(true);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    fetchGetData();
  }, []);

  const fetchGetData = async () => {
    try {
      const response = await GetServiceCaller(`${API_URL}awards`);
      if (response?.status === 200) {
        setPageLoading(false);
        const awardData = response?.data;
        setAwardTypeOptions(
          awardData?.awards?.map((record) => ({
            value: record.title_id,
            label: record.title,
          })) || []
        );
        setEmployeeOptions(
          awardData?.employeeList?.map((record) => ({
            value: record.value,
            label: record.text,
          })) || []
        );
      }
    } catch (error) {
      console.error("Fetching Error ", error);
    }
  };

  useEffect(() => {
    if (formData?.award_id) {
      fetchBadges(formData?.award_id);
    }
  }, [formData?.award_id]);

  const fetchBadges = async (id) => {
    try {
      const response = await GetServiceCaller(
        `${API_URL}awards-badges?awardID=${id}`
      );
      if (response?.status === 200) {
        const badgeUrl = response?.data?.data[0]?.FileName;
        const scoreData = response?.data?.data[0]?.score;
        const descData = response?.data?.data[0]?.remarks;
        setDescription(descData);
        setFormData((prev) => ({
          ...prev,
          badge: badgeUrl,
          badgePreview: badgeUrl ? `${API_URL}${badgeUrl}` : null,
          score: scoreData,
        }));
      }
    } catch (error) {
      console.error("Fetching Badges Error", error);
    }
  };

  const schema = Yup.object().shape({
    EmployeeID: Yup.number().required("Employee is required"),
    award_id: Yup.number().required("Title is required"),
    Remarks: Yup.string(),
  });

  const validateField = async (fieldName, updatedData) => {
    try {
      await schema.validateAt(fieldName, updatedData);
      setErrors((prev) => ({ ...prev, [fieldName]: "" }));
    } catch (err) {
      if (err.path === fieldName) {
        setErrors((prev) => ({ ...prev, [fieldName]: err.message }));
        toast.error(err.message, { position: "top-right" });
      }
    }
  };

  const handleSubmit = async (e) => {
    setLoading(true);
    e.preventDefault();
    try {
      await schema.validate(formData, { abortEarly: false });
      const formDataToSend = new FormData();
      formDataToSend.append("EmployeeID", formData.EmployeeID);
      formDataToSend.append("Name", formData.Name);
      formDataToSend.append("Remarks", formData.Remarks);
      formDataToSend.append("award_id", formData.award_id);
      if (formData.image) {
        formDataToSend.append("image", formData.image);
      }

      const response = await PostFormServiceCaller(
        `${API_URL}awards`,
        formDataToSend,
        "post",
        true // Set to true for FormData
      );

      if (response?.status === 201) {
        setLoading(false);
        toast.success("Award submitted successfully");
        setTimeout(() => navigate("/awards"), 1000);
      }
    } catch (error) {
      setLoading(false);
      if (error.inner) {
        const newErrors = {};
        error.inner.forEach((err) => {
          newErrors[err.path] = err.message;
        });
        setErrors(newErrors);
        // toast.error("Please fix the form errors", { position: "top-right" });
      } else {
        console.error("Submission Error", error);
        toast.error("Error submitting award", { position: "top-right" });
      }
    }
  };

const handleFileChange = (e) => {
  const file = e.target.files[0];

  if (!file) return;

  // 5 MB size check
  if (file.size > 2 * 1024 * 1024) {
    setErrors((prev) => ({
      ...prev,
      images: "File size should not be greater than 2 MB",
    }));
    setFormData((prev) => ({
      ...prev,
      image: "",
      imagePreview: "",
    }));
    return;
  }

  // Clear error if file is valid size
  setErrors((prev) => ({
    ...prev,
    images: "",
  }));

  const previewUrl = URL.createObjectURL(file);
  setFormData((prev) => ({
    ...prev,
    image: file,
    imagePreview: previewUrl,
  }));
};




  const handleSelect = async (selectedOption, { name }) => {
    const updatedData = {
      ...formData,
      [name]: selectedOption.value,
      ...(name === "award_id"
        ? {
            Name: selectedOption.label,
          }
        : {}),
    };
    setFormData(updatedData);
    await validateField(name, updatedData);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: name === "Name" ? value.toUpperCase() : value,
    }));
  };

  if (pageLoading) {
    return (
      <>
        <p class="position-absolute top-50 start-50 translate-middle text-center">
          <FaSpinner class="spinner" />
        </p>
      </>
    );
  } else {
    return (
      <div className="container-fluid" id="skill_section">
        <div style={{ height: "fit-content" }}>
          <form className="card rounded mt-2 p-3" onSubmit={handleSubmit}>
            <div className="row">
              <div className="col-md-4 mb-3">
                <label className="form-label">
                  Employee <span className="text-danger">*</span>
                </label>
                <Select
                  name="EmployeeID"
                  options={employeeOptions}
                  value={employeeOptions.find(
                    (o) => o.value === formData.EmployeeID
                  )}
                  onChange={handleSelect}
                  // className={errors.EmployeeID ? "is-invalid" : ""}
                  styles={{
                    margin: "0px",
                    control: (base) => ({
                      ...base,
                      borderColor: errors.EmployeeID
                        ? "#dc3545"
                        : base.borderColor,
                    }),
                  }}
                />
                {errors.EmployeeID && (
                  <div className="text-danger">{errors.EmployeeID}</div>
                )}
              </div>

              <div className="col-md-4 mb-3">
                <label className="form-label">
                  Title <span className="text-danger">*</span>
                </label>
                <Select
                  name="award_id"
                  options={awardTypeOptions}
                  value={awardTypeOptions.find(
                    (o) => o.value === formData.award_id
                  )}
                  onChange={handleSelect}
                  // className={errors.award_id ? "is-invalid" : ""}
                  styles={{
                    margin: "0px",
                    control: (base) => ({
                      ...base,
                      borderColor: errors.award_id
                        ? "#dc3545"
                        : base.borderColor,
                    }),
                  }}
                />
                {errors.award_id && (
                  <div className="text-danger">{errors.award_id}</div>
                )}
              </div>

              <div className="col-md-4 mb-3">
                <label className="form-label">Remark</label>
                <textarea
                  name="Remarks"
                  value={formData.Remarks}
                  onChange={handleChange}
                  className={`form-control ${
                    errors.Remarks ? "is-invalid" : ""
                  }`}
                  rows={1}
                />
                {errors.Remarks && (
                  <div className="invalid-feedback">{errors.Remarks}</div>
                )}
              </div>
            </div>

            <div className="row mt-2">
              <div className="col-md-4 mb-3 d-flex align-items-center">
                <div>
                  <label className="form-label me-3">Badge</label>
                  <img
                    src={formData.badge || No_Image_Available}
                    alt="Badge"
                    className="img-thumbnail rounded-circle"
                    style={{
                      width: "80px",
                      height: "80px",
                      objectFit: "cover",
                    }}
                  />
                </div>
                <div className="d-flex flex-column">
                  <div className="mx-4">
                    <b>Score</b> : {formData.score || ""}
                  </div>
                  <div className="mx-4">
                    <b>Description</b> : {description || ""}
                  </div>
                </div>
              </div>

              <div className="col-md-6 mb-3">
                <label className="form-label">Upload Image</label>
                <div className="d-flex align-items-center">
                  <input
                    type="file"
                    accept="image/*"
                    name="images"
                    onChange={handleFileChange}
                    className={`form-control ${
                      errors.image ? "is-invalid" : ""
                    }`}
                    style={{ width: "60%" }}
                  />
                    {errors.images && (
                  <div className="text-danger">{errors.images}</div>
                )}
                  {formData.imagePreview && (
                    <img
                      src={formData.imagePreview}
                      alt="Preview"
                      className="img-thumbnail rounded-circle ms-3"
                      style={{
                        width: "80px",
                        height: "80px",
                        objectFit: "cover",
                      }}
                    />
                  )}
                </div>
              </div>
            </div>

            <div className="mt-4 d-flex justify-content-end">
              <button
                type="button"
                className="cancel-btn me-2"
                onClick={() => navigate("/awards")}
              >
                Cancel
              </button>
         <button 
  type="submit" 
  className="custom-btn" 
  disabled={loading} // ✅ disable button while loading
>
  {loading ? <FaSpinner className="sm-spinner" /> : "Submit"}
</button>

            </div>
          </form>
        </div>
      </div>
    );
  }
};

export default AwardForm;
